﻿(function () {
  function initMenu() {
    var toggle = document.querySelector(".pt-nav-toggle");
    var nav = document.querySelector("#PtMainNav");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      var expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!expanded));
      nav.classList.toggle("is-open", !expanded);
    });
    nav.addEventListener("click", function (event) {
      if (!event.target.closest("a")) return;
      toggle.setAttribute("aria-expanded", "false");
      nav.classList.remove("is-open");
    });
  }

  function initCarousel() {
    document.querySelectorAll("[data-pt-carousel]").forEach(function (carousel) {
      var slides = Array.prototype.slice.call(carousel.querySelectorAll("[data-pt-slide]"));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll("[data-pt-dot]"));
      var prev = carousel.querySelector("[data-pt-prev]");
      var next = carousel.querySelector("[data-pt-next]");
      if (slides.length < 2 || slides.length !== dots.length) return;
      var active = Math.max(0, slides.findIndex(function (slide) {
        return slide.classList.contains("is-active");
      }));
      var timer;

      function show(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === active;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-hidden", String(!isActive));
        });
        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === active;
          dot.classList.toggle("is-active", isActive);
          dot.setAttribute("aria-selected", String(isActive));
        });
      }

      function start() {
        window.clearInterval(timer);
        timer = window.setInterval(function () {
          show(active + 1);
        }, 5200);
      }

      function move(direction) {
        show(active + direction);
        start();
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener("click", function () {
          show(index);
          start();
        });
      });
      if (prev) prev.addEventListener("click", function () { move(-1); });
      if (next) next.addEventListener("click", function () { move(1); });
      carousel.addEventListener("mouseenter", function () {
        window.clearInterval(timer);
      });
      carousel.addEventListener("mouseleave", start);
      show(active);
      start();
    });
  }
  function packUnitsFromSelect(select) {
    if (!select || !select.selectedOptions || !select.selectedOptions[0]) return 1;
    return Number(select.selectedOptions[0].getAttribute("data-pack-units")) || 1;
  }

  function initPackForms() {
    document.querySelectorAll(".pt-product-form").forEach(function (form) {
      var select = form.querySelector("[data-pt-pack-select]");
      var counts = Array.prototype.slice.call(form.querySelectorAll("[data-pt-flavor-count]"));
      var balance = form.querySelector("[data-pt-flavor-balance]");
      var error = form.querySelector("[data-pt-pack-error]");
      if (!select || counts.length === 0) return;

      function currentTotal() {
        return counts.reduce(function (sum, input) {
          return sum + (Number(input.value) || 0);
        }, 0);
      }

      function setDefaultCounts() {
        var units = packUnitsFromSelect(select);
        counts.forEach(function (input, index) {
          input.value = index === 0 ? String(units) : "0";
          input.max = String(units);
        });
        updateBalance();
      }

      function updateBalance() {
        var units = packUnitsFromSelect(select);
        var total = currentTotal();
        var remaining = units - total;
        if (!balance) return true;
        balance.classList.toggle("is-balanced", remaining === 0);
        balance.classList.toggle("is-over", remaining < 0);
        if (remaining === 0) {
          balance.textContent = total + "/" + units + " selected. Pack is complete.";
          return true;
        }
        if (remaining > 0) {
          balance.textContent = total + "/" + units + " selected. Choose " + remaining + " more.";
          return false;
        }
        balance.textContent = total + "/" + units + " selected. Remove " + Math.abs(remaining) + ".";
        return false;
      }

      select.addEventListener("change", setDefaultCounts);
      counts.forEach(function (input) {
        input.addEventListener("input", updateBalance);
      });
      form.addEventListener("submit", function (event) {
        if (updateBalance()) return;
        event.preventDefault();
        if (error) {
          error.hidden = false;
          error.textContent = "Flavor counts must equal the selected pack size before checkout.";
        }
      });
      setDefaultCounts();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMenu();
    initCarousel();
    initPackForms();
  });
})();

